import client from "./client";

export const authApi = {
  register: (data) => client.post("/auth/register", data),
  login: (email, password) => client.post("/auth/login", { email, password }),
  refresh: () => client.post("/auth/refresh"),
  me: () => client.get("/auth/me"),
  logout: () => client.post("/auth/logout"),
  updateMe:  (data)       => client.patch("/auth/me", data),
  togglePin: (projectId) => client.patch(`/auth/me/pins/${projectId}`),

  // SSO: redirect the browser to the backend OAuth endpoint
  googleLogin: () => {
    const base = process.env.REACT_APP_API_URL || "";
    window.location.href = `${base}/api/auth/google`;
  },
  microsoftLogin: () => {
    const base = process.env.REACT_APP_API_URL || "";
    window.location.href = `${base}/api/auth/microsoft`;
  },
};
